import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIntegrations: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconIntegrations"><Path d="M17.4141 12L9 20.4141L0.585938 12L9 3.58594L17.4141 12Z" fill="currentColor"/><Path d="M23.2383 12L14.8242 20.4141L12.9121 18.502L19.4141 12L12.9121 5.49805L14.8242 3.58594L23.2383 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIntegrations;
